export default __webpack_public_path__ + "static/media/CheckoutAd.0225fbee.png";